import apiCall from 'apps/investment/apiCalls/bank-accounts';
import { DynamicFilterForm } from 'common/dynamic-filter-form';
import { DetailPage, ListPage } from 'common/ui/admin-CRUD/page';
import { columnsGenerator } from './config';
import ItemDetail from './detail';

export const BankAccountListPage = props => (
  <ListPage
    title="All Bank Accounts"
    apiCall={apiCall}
    columnsGenerator={columnsGenerator}
    FilterForm={DynamicFilterForm}
    resourceName="data"
    {...props}
  />
);

export const BankAccountDetailPage = props => (
  <DetailPage
    title="Bank Account"
    apiCall={apiCall}
    listUrl={`/investment/bank-accounts`}
    ItemDetail={ItemDetail}
    resourceName="data"
    {...props}
  />
);
